import 'core-js/stable';
import 'regenerator-runtime/runtime';

import '../common/styles-v2/app.scss';
import '../common/styles/app.scss';

import React from 'react';

import Cookies from 'js-cookie';
import { assocPath, lens, path, set } from 'ramda';
import { hydrate } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useSSR } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import smoothscroll from 'smoothscroll-polyfill';

import MainLayout from '../common/components/MainLayout';
import { ROUTES } from '../common/config/routes';
import { configureStore } from '../common/config/store';
import { ensureReady } from '../common/routing/ensureReady';
import { setupI18n } from './i18n';

smoothscroll.polyfill();

const PATH = ['state', 'rgpd'];
const GDPRConfiguration = lens(path(PATH), (value, obj) =>
  value ? assocPath(PATH, value, obj) : obj
);

const getSavedGDPRConfiguration = () => {
  let config;

  try {
    config = JSON.parse(Cookies.get('rgpd'));
    // config = JSON.parse(localStorage.getItem('rgpd'));
  } catch (e) {
    config = null;
  }

  return config;
};

const getStore = ({ state }) => configureStore(state);

const MainApp = ({ store, data }) => {
  useSSR(window.initialI18nStore, window.initialLanguage);

  return (
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter>
          <MainLayout data={data} store={store} routes={ROUTES} />
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  );
};

ensureReady(ROUTES).then(async (data) => {
  await setupI18n(data?.state?.locale);

  const store = getStore(
    set(GDPRConfiguration, getSavedGDPRConfiguration(), data)
  );

  return hydrate(
    <MainApp store={store} data={data} />,
    document.getElementById('root')
  );
});

if (module.hot) {
  module.hot.accept();
}
